module.exports = __webpack_public_path__ + "static/img/banner.4e28e0a1.jpg";